import React, { Dispatch, SetStateAction, useState } from "react"
import { CartContainer } from "../../Order/ManageOrder/RefundOrder/Cart/Cart.styled"
import * as graphql from "lib/types/generated/graphql-types"
import {
  CustomReasonCode,
  Maybe,
  Order,
  OrderHistory,
  OrderOperationSearchHit
} from "lib/types/generated/graphql-types"
import Reason from "../../Order/Updates/Reason"
import { ArrowIcon, OrderLabel } from "../Shared.styled"
import { Link } from "react-router-dom"
import StartOperation from "./StartOperation"
import { useMutation } from "@apollo/client"
import { handleErrorMessages } from "helpers/errors"
import START_CANCELLATION from "../../../graphql/mutations/order/cancellation/StartCancellation"
import FailedCancellation from "../../Order/ManageOrder/CancelOrder/FailedCancellation"

type Props = {
  operation: OrderOperationSearchHit
  order: Order
  orderHistory: OrderHistory
  getCustomCode: (code: Maybe<string> | undefined) => CustomReasonCode
  setShow: Dispatch<SetStateAction<boolean>>
  setCreatedOperations: Dispatch<SetStateAction<OrderOperationSearchHit[]>>
  refetchOrder?: () => void
  setFailedOperations: Dispatch<SetStateAction<OrderOperationSearchHit[]>>
  isOperationBlocked?: boolean
  blockedReason?: string
}

const CancellationAction = ({
  operation,
  order,
  orderHistory,
  getCustomCode,
  setShow,
  setCreatedOperations,
  setFailedOperations,
  isOperationBlocked = false,
  blockedReason = ""
}: Props) => {
  const [giftCardAction, setGiftCardAction] = useState<graphql.InputActionGiftCard>({
    actionType: graphql.InputActionType.Auto
  })
  const [bonusAction, setBonusAction] = useState<graphql.InputActionBonus>({
    actionType: graphql.InputActionType.Auto
  })
  const [paymentAction, setPaymentAction] = useState<graphql.InputActionPaymentRefund>({
    actionType: graphql.InputActionType.Auto
  })

  const [startCancellation, { loading }] = useMutation(START_CANCELLATION, {
    onCompleted: () => {
      setShow(false)
      setCreatedOperations((prev) => prev.filter((hit) => hit.id !== operation.id))
    },
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const startOrderCancellation = () => {
    startCancellation({
      variables: {
        cancellationId: cancellation?.id,
        input: {
          ...(cancellation?.bonus && { bonus: bonusAction }),
          ...(cancellation?.giftCards &&
            cancellation?.giftCards?.length > 0 && { giftCard: giftCardAction }),
          payment: paymentAction
        }
      }
    })
  }

  const cancellation = order.Cancellations.find((cancellation) => cancellation.id === operation.id)

  const isCancellationFailed = cancellation?.failed && !cancellation.completed

  if (isCancellationFailed)
    return (
      <>
        <OrderLabel>
          Order: {order.reference}{" "}
          <Link to={`/orders/${order.id}`} target="_blank">
            <ArrowIcon />
          </Link>
        </OrderLabel>
        <FailedCancellation
          orderId={order.id}
          failedCancellation={cancellation}
          orderHistory={orderHistory.history}
          setFailedOperations={setFailedOperations}
          isOperationBlocked={isOperationBlocked}
          blockedReason={blockedReason}
        />
      </>
    )

  return (
    <>
      <CartContainer key={cancellation?.id}>
        <OrderLabel>
          Order: {order.reference}{" "}
          <Link to={`/orders/manage-order/${order.id}`} target="_blank">
            <ArrowIcon />
          </Link>
        </OrderLabel>
        <Reason reason={cancellation?.reason} getCustomCode={getCustomCode} />
        <StartOperation
          operation={cancellation}
          actionState={{
            giftCardAction,
            setGiftCardAction,
            bonusAction,
            setBonusAction,
            paymentAction,
            setPaymentAction
          }}
          startOperation={startOrderCancellation}
          loading={loading}
          disabled={isOperationBlocked}
          blockedReason={blockedReason}
        />
      </CartContainer>
    </>
  )
}

export default CancellationAction
